<template>
  <div>
    <div :class="$style.section">
      <Select
        v-model="manualEntry"
        data-test-id="FieldsUserState__manualEntry"
        label="Manual / Single User API"
        name="manualEntry"
        :options="stateList"
        :showValidationMessage="false"
      />
      <Select
        v-model="csvImport"
        data-test-id="FieldsUserState__csvImport"
        label="CSV Import / Bulk User API Import"
        name="csvImport"
        :options="stateList"
        :showValidationMessage="false"
      />
      <Select
        v-model="applicationImport"
        data-test-id="FieldsUserState__applicationImport"
        label="Application / Directory Integrations"
        name="applicationImport"
        :options="stateList"
        :showValidationMessage="false"
      />
    </div>
  </div>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { Select } from '@jumpcloud/ui-components';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

const {
  ModuleConsts,
} = Constants;

const { activated, staged } = ModuleConsts.systemUser.accountStates;

const kbUrl = KbArticleUrls.managingUserStates;
export default {
  name: 'FieldsUserState',

  components: {
    Select,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      kbUrl,
    };
  },

  userStateMap: new Map([
    [activated, 'Active'],
    [staged, 'Staged'],
  ]),

  computed: {
    applicationImport: {
      ...createComputedObjectBinding('applicationImport'),
    },

    csvImport: {
      ...createComputedObjectBinding('csvImport'),
    },

    manualEntry: {
      ...createComputedObjectBinding('manualEntry'),
    },

    stateList() {
      const userStates = [
        {
          name: this.$options.userStateMap.get(activated),
          value: activated,
        }, {
          name: this.$options.userStateMap.get(staged),
          value: staged,
        },
      ];

      return userStates;
    },
  },
};
</script>

<style module>
.section {
  --input-wrapper-width: 30ch;

  display: grid;
  gap: var(--jc-spacer);
  margin-bottom: var(--jc-spacer-small);
}

.instructions {
  color: var(--jc-color-neutral-text-descriptive);
}
</style>
